import axios from 'axios';
import prepareRequestOptions, {
  prepareS3UploadRequestOptions,
} from '../utils/admin-apis.util';

export const getListData = async (params = '', filters = {}, signal = null) => {
  const options = prepareRequestOptions(
    `/admin/content/videos/list${params}`,
    'POST',
    filters,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/video/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/video/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content/video/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/video/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const playbackDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/videos/${id}/playback`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getVideoDescriptionList = async (
  params = '',
  filters = {},
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/content/video/descriptions/list${params}`,
    'POST',
    filters,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const updateVideoDescription = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/video/descriptions/update',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const bulkUpdateDataByIds = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/videos/bulk-update',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelVideoScheduleList = async (
  params = '',
  filters = {},
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/content/video/schedule/list${params}`,
    'POST',
    filters,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getVideosCountForRulesetsByChannel = async (id, type) => {
  const options = prepareRequestOptions(
    `/admin//channel/${id}/ruleset/videos-count?type=${type}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const channelVideoSchedule = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/content/video/schedule/manage`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateVideoSchedule = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/video/schedule/update',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateLicenseExpirationDate = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/videos/update-license-expiration',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const inlineUpdateDataByIds = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/videos/inline-update',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const assignChannelsToVideo = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content/video/${id}/assign/channels`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSignedUrl = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/generate-signed-url',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const uploadFileToS3 = async (payload, url, onUploadProgress = null) => {
  const options = prepareS3UploadRequestOptions(
    url,
    'PUT',
    payload,
    false,
    onUploadProgress
  );

  const response = await axios(options);
  return response.data;
};

export const listExportVideoData = async () => {
  const options = prepareRequestOptions(
    `/admin/content/videos/export-data/list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const exportVideosData = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/content/videos/export`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const downloadExportVideosData = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/videos/export/${id}/download`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const addVideosToHealthCheckQueue = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/videos/health-check/queue/add',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSignedUrlOfCDN77 = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/upload-assets',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getMultipartSignedUrl = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/generate-multipart-url',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getVideoUploadURL = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/get-upload-url',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
export const completeVideoUpload = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/complete-upload',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const reprocessVideoAsset = async (id, isTrailer) => {
  const options = prepareRequestOptions(
    `/admin/content/video/${id}/asset/reprocess?isTrailer=${isTrailer}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
